import { loadImage } from './load-image';

/**
 * Os cantos que sobram na rotação ficam brancos: canvas vazio é transparente e
 * transparente vira preto quando o recorte sai em JPEG.
 */
const FILL_COLOR = '#ffffff';
const JPEG_QUALITY = 0.95;

/** Caixa envolvente da imagem depois de girada `radians`. */
function rotatedBoundingBox(
  width: number,
  height: number,
  radians: number,
): { width: number; height: number } {
  const cos = Math.abs(Math.cos(radians));
  const sin = Math.abs(Math.sin(radians));
  return {
    width: Math.round(width * cos + height * sin),
    height: Math.round(width * sin + height * cos),
  };
}

/**
 * Devolve a imagem girada `degrees` graus, desenhada numa caixa que a contém
 * por inteiro. É esta imagem que vai para a moldura, de forma que o recorte
 * trabalhe sempre nas coordenadas do que está na tela.
 *
 * `degrees === 0` devolve a origem sem passar pelo canvas.
 */
export async function rotateImageToDataUrl(
  imageSrc: string,
  degrees: number,
): Promise<string> {
  if (degrees === 0) return imageSrc;

  const image = await loadImage(imageSrc);
  const sourceWidth = image.naturalWidth || image.width;
  const sourceHeight = image.naturalHeight || image.height;
  const radians = (degrees * Math.PI) / 180;
  const box = rotatedBoundingBox(sourceWidth, sourceHeight, radians);

  const canvas = document.createElement('canvas');
  canvas.width = box.width;
  canvas.height = box.height;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('CANVAS_CONTEXT_UNAVAILABLE');

  ctx.fillStyle = FILL_COLOR;
  ctx.fillRect(0, 0, box.width, box.height);
  ctx.translate(box.width / 2, box.height / 2);
  ctx.rotate(radians);
  ctx.drawImage(image, -sourceWidth / 2, -sourceHeight / 2);

  return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
}
